export enum SigningTaskStatus {
    Open = 0,
    Completed = 1,
    Rejected = 2,
    Skipped = 3
}